const EDITABLE_SHEET_EXTENSIONS = ['xlsx', 'xls', 'csv'];

/** True when the file name looks like a spreadsheet we can open in the editor. */
export const isEditableSheetFile = (fileName?: string): boolean => {
    const ext = fileName?.split('.').pop()?.toLowerCase() ?? '';
    return EDITABLE_SHEET_EXTENSIONS.includes(ext);
};
